"use client";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { JopiThemeProvider } from "@quintoandar-tokko/jopijs";
import { THEMES } from "@/store/slices/ThemeSlice";
import JOPI_UNIVEN_BRAND from "@/theme/brands/univen";
import JOPI_NEUTRAL_BRAND from "@/theme/brands/neutral";

const BRANDS = {
  [THEMES.TOKKOBROKER]: undefined, // jopi's default
  [THEMES.UNIVEN]: JOPI_UNIVEN_BRAND,
};

// The theme stays null until the page payload says Tokko or Univen. Until
// then jopi gets a neutral brand and <html data-theme> stays unset, which
// designTokens.css renders as neutral greys — so no brand flashes.
export default function ThemeClient({ children }) {
  const theme = useSelector((state) => state.ThemeSlice.theme);
  const brand = theme ? BRANDS[theme] : JOPI_NEUTRAL_BRAND;

  useEffect(() => {
    if (theme) {
      document.documentElement.setAttribute("data-theme", theme);
    }
  }, [theme]);

  return (
    <JopiThemeProvider brand={brand} syncDocumentTheme={false}>
      {children}
    </JopiThemeProvider>
  );
}
